import { Flex, Typography, Select } from "antd";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { DocstoreUploadForm, FieldConfig } from "../../model/types";

interface IModalSelect {
  fieldConfig: FieldConfig;
  control: Control<DocstoreUploadForm>;
}

export function ModalSelect({ fieldConfig, control }: IModalSelect) {
  return (
    <Flex vertical gap="4px">
      <Typography.Text>{fieldConfig.title}</Typography.Text>
      <FormItem<DocstoreUploadForm>
        name={fieldConfig.name as keyof DocstoreUploadForm}
        control={control}
        style={{ marginBottom: 0 }}
      >
        <Select options={fieldConfig.options} />
      </FormItem>
    </Flex>
  );
}
